module.exports = __webpack_public_path__ + "img/foot-back.de6ad694.png";